<template>
    <div v-loading="$parentInfo.pastReturnVisit.loading">
        <div class="m-portlet">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <el-row :gutter="20">
                            <el-form label-width="150px">
                                <el-col :span="2">
                                    回访情况
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="回访日期">
                                        <el-date-picker
                                                v-model="$parentInfo.pastReturnVisit.complaintsDate"
                                                type="date"
                                                placeholder="选择日期"
                                                value-format="yyyy-MM-dd"
                                                @change="handleShowReturnVisit()"
                                                style="width: 150px;">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="拨号人">
                                        <el-input
                                                placeholder="请输入班主任"
                                                v-model="$parentInfo.pastReturnVisit.returnVisitor"
                                                @change="handleShowReturnVisit()"
                                                style="width:150px;">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="家长">
                                        <el-input
                                                placeholder="请输入家长姓名"
                                                v-model="$parentInfo.pastReturnVisit.parentsName"
                                                @change="handleShowReturnVisit()"
                                                style="width:150px;">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-form>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body" style="margin-top: -20px" :style="{'height': $parentInfo.clientHeight-650+$parentInfo.heightChange+'px'}">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>回访时间</th>
                        <th>拨号人</th>
                        <th>被回访人</th>
                        <th>开始回访时间</th>
                        <th>回访时长</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in returnVisit_order" :key="index">
                        <td>{{item.return_date}}</td>
                        <td v-if="item.head_teacher">
                            <div v-if="item.head_teacher.employee">{{item.head_teacher.employee.name}}</div>
                            <div v-else>数据缺失</div>
                        </td>
                        <td v-else>数据缺失</td>
                        <!--学生是被回访人-->
                        <td v-if="item.parent">家长：{{item.parent.name}}</td>
                        <td v-else>学生：{{$parentInfo.student.name}}</td>
                        <td>{{item.created_at}}</td>
                        <td>{{item.return_time}}</td>
                        <td>
                            <el-button type="primary" plain
                                       @click="handleCheckReturn(item.id)"
                                       :disabled="!$parentInfo.pastReturnVisit.disableYN">查看回访内容
                            </el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="text-center m-t-10">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="$parentInfo.pastReturnVisit.currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="$parentInfo.pastReturnVisit.total">
            </el-pagination>
        </div>
    </div>

</template>

<script>
    export default {
        name: "pastReturnVisit",
        data() {
            return {}
        },
        computed: {
            returnVisit_order: function () {
                return this._.orderBy(this.$parentInfo.pastReturnVisit.returnVisit, 'id', 'desc');
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowReturnVisit();
        },

        methods: {
            handleShowReturnVisit(currentPage = 1, currentPageSize = 10) {
                this.$wApi.send(this.$parentInfo.path, 'pastReturnVisit', {
                    'student_id': this.$parentInfo.student_id,
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                    'returnVisitor': this.$parentInfo.pastReturnVisit.returnVisitor,
                    'parentsName': this.$parentInfo.pastReturnVisit.parentsName,
                    'complaintsDate': this.$parentInfo.pastReturnVisit.complaintsDate,
                });
            },
            handleCheckReturn(id) {
                this.$Win.openModal('Dialog_PastReturnDetail', 600, 600, '查看回访详情', {
                    'id': id,
                });
            },
            handleSizeChange(val) {
                this.$parentInfo.pastReturnVisit.currentPageSize = val;
                this.handleShowReturnVisit(this.$parentInfo.pastReturnVisit.currentPage, this.$parentInfo.pastReturnVisit.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleShowReturnVisit(this.$parentInfo.pastReturnVisit.currentPage, this.$parentInfo.pastReturnVisit.currentPageSize)
            }
        }
    }
</script>

<style>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
